// extracted by mini-css-extract-plugin
export default {"root":"ChangeOrgMemberRoleForm_root__4SNFK","error":"ChangeOrgMemberRoleForm_error__cMrjm","actions":"ChangeOrgMemberRoleForm_actions__WImJI"};